import { downloadTextFile } from "./common";

/**
 * CSV s točka-zarezom kao razdjelnikom — Excel na hrvatskim postavkama zarez čita
 * kao decimalni znak, pa bi zarez razbio stupce.
 */
const escapeValue = (value: string | number | null | undefined): string => {
  if (value === null || value === undefined) return "";

  const text = String(value);
  if (!/[;"\n]/.test(text)) return text;

  return `"${text.replace(/"/g, '""')}"`;
};

export const toCsv = (
  rows: Record<string, string | number | null | undefined>[],
  headers: string[]
): string =>
  [
    headers.join(";"),
    ...rows.map((row) => headers.map((header) => escapeValue(row[header])).join(";")),
  ].join("\n");

/** BOM ide na početak da Excel prepozna UTF-8 i ispravno prikaže hrvatska slova. */
export const downloadCsv = (content: string, fileName: string) =>
  downloadTextFile(`﻿${content}`, fileName, "text/csv;charset=utf-8");
